import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { sanitizeHtml } from "../../../../../utils/commonfunction";

const ReceiptInvoice = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchReceipt = async () => {
      try {
        const rawBase = process.env.REACT_APP_API_URL || "http://localhost:7000";
        const cleanBase = rawBase.replace(/\/$/, "");
        const fullUrl = cleanBase.includes("/webservice/api/v1")
          ? `${cleanBase}/common/users/billing-receipt/${id}`
          : `${cleanBase}/webservice/api/v1/common/users/billing-receipt/${id}`;

        console.log("Fetching receipt HTML from:", fullUrl);
        const res = await fetch(fullUrl);
        if (!res.ok) {
          throw new Error(`Failed to load receipt (Status: ${res.status})`);
        }
        const html = await res.text();
        setData(html);
      } catch (err) {
        console.error("Error fetching receipt:", err);
        setError(err.message || "Failed to load receipt");
      } finally {
        setLoading(false);
      }
    };
    if (id) fetchReceipt();
  }, [id]);

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "80vh", fontFamily: "sans-serif" }}>
        <h3>Loading Receipt...</h3>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ textAlign: "center", padding: "40px", fontFamily: "sans-serif" }}>
        <h3 style={{ color: "#ef4444" }}>Error Loading Receipt</h3>
        <p style={{ color: "#64748b" }}>{error}</p>
      </div>
    );
  }

  return (
    <div style={{ width: "100%", minHeight: "100vh", backgroundColor: "#f8fafc" }} dangerouslySetInnerHTML={{ __html: sanitizeHtml(data) }} />
  );
};

export default ReceiptInvoice;
